export const provinceI18n = {
  dolnoslaskie: "dolnośląskie",
  "kujawsko-pomorskie": "kujawsko-pomorskie",
  lubelskie: "lubelskie",
  lubuskie: "lubuskie",
  lodzkie: "łódzkie",
  malopolskie: "małopolskie",
  mazowieckie: "mazowieckie",
  opolskie: "opolskie",
  podkarpackie: "podkarpackie",
  podlaskie: "podlaskie",
  pomorskie: "pomorskie",
  slaskie: "śląskie",
  swietokrzyskie: "świętokrzyskie",
  "warminsko-mazurskie": "warmińsko-mazurskie",
  wielkopolskie: "wielkopolskie",
  zachodniopomorskie: "zachodniopomorskie",
};
